import { Badge, BadgeProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MessageTemplate } from '../message-template'

// approved reads success, pending is warning, rejected is error.
const statusBadge: Record<MessageTemplate['status'], BadgeProps['status']> = {
    APPROVED: 'success',
    PENDING: 'warning',
    REJECTED: 'error',
}

export type TemplateStatusBadgeProps = {
    status: MessageTemplate['status']
} & Omit<BadgeProps, 'status' | 'text'>

export function TemplateStatusBadge({ status, ...props }: TemplateStatusBadgeProps) {
    const { t } = useTranslation()

    return (
        <Badge
            status={statusBadge[status]}
            text={t(`templateStatuses.${status}`)}
            {...props}
        />
    )
}
